export const LOT_TYPES: Record<LOTLevel, string> = {
  career_area: 'Career Area',
  occupation_group: 'Occupation Group',
  occupation: 'Occupation',
  specialized_occupation: 'Specialized Occupation'
};
